import { useState, useEffect, useRef, useContext } from "react";
import Context from "../../storage/context";
import ImageZoomModal from "../ImageZoomModal/ImageZoomModal";

const MAX_IMGS = 6;

function Checkbox({ checked, onChange, label }) {
    return (
        <label className="ck" onClick={() => onChange(!checked)}>
            <div className={`ck-b${checked ? " on" : ""}`}>
                {checked && <CheckIcon />}
            </div>
            {label}
        </label>
    );
}

const CheckIcon = () => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

function Images({ images, setImages }) {
    let ctx = useContext(Context);
    const refs = useRef([]);

    const addFile = (idx, file) => {
        if (!file?.type.startsWith("image/")) return;
        const url = URL.createObjectURL(file);
        setImages(prev => {
            const next = [...prev];
            const isFirst = prev.filter(Boolean).length === 0;
            next[idx] = { url, file, primary: isFirst };
            return next;
        });
    };

    const remove = (idx, e) => {
        e.stopPropagation();
        setImages(prev => {
            const next = [...prev];
            if (next[idx]?.url) URL.revokeObjectURL(next[idx].url);
            const wasPrimary = next[idx]?.primary;
            next[idx] = null;
            if (wasPrimary) {
                const fi = next.findIndex(Boolean);
                if (fi !== -1) next[fi] = { ...next[fi], primary: true };
            }
            return next;
        });
    };

    const setPrimary = (idx, val) => {
        setImages(prev => prev.map((img, i) =>
            img ? { ...img, primary: i === idx ? val : (val ? false : img.primary) } : null
        ));
    };

    const filled = images.filter(Boolean);

    return (
        <>
            {/* preview strip */}
            <div className="ps-strip">
                {filled.length === 0
                    ? <div className="ps-empty"><span>📷</span>טרם נוספו תמונות</div>
                    : filled.map((img, i) => (
                        <div key={i} className={`ps-item${img.primary ? " prim" : ""}`}>
                            <ImageZoomModal src={img.url.startsWith("/uploads/") ? `${ctx.api_url}${img.url}` : img.url} />
                            {img.primary && <span className="ps-badge">ראשית</span>}
                        </div>
                    ))
                }
            </div>

            {/* slots */}
            <div className="ig">
                {Array.from({ length: MAX_IMGS }).map((_, idx) => {
                    const img = images[idx];
                    return (
                        <div
                            key={idx}
                            className={`is${img ? " filled" : ""}`}
                            onClick={() => !img && refs.current[idx]?.click()}
                        >
                            {img ? (
                                <>
                                    <img src={img.url.startsWith("/uploads/") ? `${ctx.api_url}${img.url}` : img.url} alt="" className="is-prev" loading="lazy" />
                                    {img.primary && <span className="is-badge">ראשית</span>}
                                    <button className="is-rm" onClick={e => remove(idx, e)} type="button">✕</button>
                                    <div className="is-pck" onClick={e => e.stopPropagation()}>
                                        <Checkbox
                                            checked={!!img.primary}
                                            onChange={v => setPrimary(idx, v)}
                                            label="ראשית"
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <span className="is-plus">＋</span>
                                    <span className="is-lbl">תמונה {idx + 1}</span>
                                </>
                            )}
                            <input
                                ref={el => (refs.current[idx] = el)}
                                type="file" accept="image/*" style={{ display: "none" }}
                                onChange={e => addFile(idx, e.target.files[0])}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default Images;